import React from 'react';
import './AssignRoleComponent.css';

const AssignRoleComponent = () => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="user_role_manager">
              <div className="row">
                <div className="col-lg-12">
                  <h6>Total Users : 77</h6>
                </div>

                {/* Search Section */}
                <div className="col-lg-6 mb-2">
                  <div className="serach_item_name_section">
                    <div className="input-group">
                      <div className="form-outline">
                        <input
                          type="text"
                          placeholder="Search by Name"
                          className="form-control"
                        />
                      </div>
                      <button type="button" className="common_btn">
                        <i className="bi bi-search"></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Create User Button */}
                <div className="col-lg-6 mb-2">
                  <button className="common_btn btn btn-primary common_btn_pd pull-right" type="button">
                    Create User
                  </button>
                </div>

                {/* Table Section */}
                <div className="table-responsive custom-table-01">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Action</th>
                        <th>Name</th>
                        <th>Profile</th>
                        <th>Role</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td className="all-action-wdth">
                          <button className="common_btn view-data-btn action-btn-rgt-spc">
                            Change User Role
                          </button>
                          <button className="common_btn view-data-btn action-btn-rgt-spc">
                            User Point
                          </button>
                          <button className="common_btn btn-info">User Info</button>
                          <button className="common_btn btn-info">User Referrals</button>
                        </td>
                        <td>Jyoti Bhardwaj</td>
                        <td>
                          <img
                            src="/image/unisexImage.jpeg"
                            className="table_manager_role_img_wdth"
                            alt="User Profile"
                          />
                        </td>
                        <td>Admin</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignRoleComponent;
